module.exports = __webpack_public_path__ + "static/media/MISSIONS@3x.e6cbdce7.png";